import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BiomethaneIcon from '@/assets/biomethane-icon';
import RightCard from '@/views/home_view/components/right-card/RightCard';

import useConfigStore from '@/store/configStore';

import { appRoutes } from '@/config/appRoutes';

export default function ProducerCard() {
  const navigate = useNavigate();
  const environmentSettings = useConfigStore((state) => state.environmentSettings);

  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    navigate(`${environmentSettings?.BASE_PATH ?? ''}${appRoutes.PRODUCER}`);
  }, [navigate, environmentSettings]);

  // const disabled = useMemo(
  //   () => user?.companies?.[0]?.company.companyType?.code !== COMPANY_TYPE.PRODUCER && user?.role !== ROLES.MOEVE_ADMIN,
  //   [user]
  // );
  const disabled = true;

  return (
    <RightCard
      title={t('home.producerCard.title')}
      description={t('home.producerCard.description')}
      backgroundColor="var(--palette-secondary-main)"
      textColor="var(--palette-text-primary)"
      iconColor="var(--palette-text-primary)"
      Icon={BiomethaneIcon}
      disabled={disabled}
      onClick={handleClick}
    />
  );
}
